var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 818.84 818.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674.11,275.58c-6.35-23.92-25.07-42.77-48.84-49.16-43.08-11.62-215.85-11.62-215.85-11.62,0,0-172.76,0-215.84,11.62-23.77,6.39-42.49,25.24-48.85,49.16-11.54,43.36-11.54,133.84-11.54,133.84,0,0,0,90.48,11.54,133.84,6.35,23.92,25.08,42.77,48.85,49.16,43.08,11.62,215.84,11.62,215.84,11.62,0,0,172.76,0,215.85-11.62,23.77-6.4,42.49-25.24,48.84-49.16,11.54-43.36,11.54-133.84,11.54-133.84,0,0,0-90.47-11.54-133.84ZM352.92,491.56v-164.29l144.4,82.15-144.4,82.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M409.42,815.84C185.32,815.84,3,633.52,3,409.42S185.32,3,409.42,3s406.42,182.32,406.42,406.42-182.32,406.42-406.42,406.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.59de4555.svg";
export { ForwardRef as ReactComponent };